import { FormattedMessage } from "react-intl";

import { Button } from "ui/Button/Button";
import { Modal } from "ui/Modal/Modal";
import { BodyM, HeaderS } from "ui/Typography/Typography";

type RemoveFiltersModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function RemoveFiltersModal({ isOpen, onClose, onConfirm }: RemoveFiltersModalProps) {
  return (
    <Modal
      trapFocus={false}
      closeOnOverlayClick={false}
      isCentered
      isOpen={isOpen}
      onClose={onClose}
    >
      <Modal.Content maxW="295px" pt="s300" px="s200" pb="s200">
        <Modal.Body p="0">
          <HeaderS textAlign="center">
            <FormattedMessage id="flows.inventory.restocking-list.filters.remove-all-modal.title" />
          </HeaderS>
          <BodyM mt="s100" textAlign="center" color="grey.700">
            <FormattedMessage id="flows.inventory.restocking-list.filters.remove-all-modal.description" />
          </BodyM>
        </Modal.Body>
        <Modal.Footer p="0" mt="s200" flexDir="column" gap="s100">
          <Button onClick={onConfirm} variant="primary" size="lg" isFullWidth>
            <FormattedMessage id="flows.inventory.restocking-list.filters.remove-all-modal.cta.primary" />
          </Button>
          <Button onClick={onClose} variant="secondary" size="lg" isFullWidth>
            <FormattedMessage id="flows.inventory.restocking-list.filters.remove-all-modal.cta.secondary" />
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}
